
import {permissionList} from "@/api/http";

const columnList: Array<column> = [
    {
        prop: "basicset_name",
        label: "名称",
        width: 355,
    },
    {
        prop: "basicset_order",
        label: "值",
        width: 355,
    },
];
import { defineComponent, ref, reactive, inject, onMounted, watch } from "vue";
import { Request } from "@/api/request";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "Reappearance",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["返现方案"]);
        let tableData = ref([] as Array<any>),
            loading = ref(true),
            roleList = ref({} as any),
            headClass = inject("headClass"),
            dialogFormVisible = ref(false),
            dialogTitle = ref("新增方案"),
            formRef = ref(null),
            form = ref({
                name: "",
                sort: 1,
                id: 0,
            }),
            father = ref({ id: 0, name: null }),
            isEdit = ref(false),
            edit = (data: any): void => {
                dialogTitle.value = "编辑方案";
                isEdit.value = true;
                dialogFormVisible.value = true;
                form.value = {
                    name: data.basicset_name,
                    sort: data.basicset_order,
                    id: data.basicset_id,
                };
            },
            setStatus = (basicset_id: number, status: number) => {
                Request.axiosInstance({
                    url: "adminapi/Basicset/upState",
                    data: {
                        basicset_id,
                        basicset_type: 10,
                        status: status == 0 ? 1 : 0,
                    },
                }).then(callback);
            },
            callback = (res: any): void => {
                dialogFormVisible.value = false;
                if (res.status == 202 || res.status == 200) {
                    getTableData();
                }
            },
            submitForm = (): void => {
                let data:any = {
                    basicset_name: form.value.name,
                    basicset_order: form.value.sort,
                    basicset_type: 10,
                };
                let url ="adminapi/Basicset/create";
                if (isEdit.value) {
                    url = 'adminapi/Basicset/editInfo';
                    data = {
                        ...data,
                        basicset_id:form.value.id
                    }
                }
                Request.axiosInstance({
                    url,
                    data,
                }).then(callback);
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'reappearance',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                Request.axiosInstance({
                    url: "adminapi/Basicset/list",
                    data: {
                        basicset_type: 10,
                    },
                }).then((res: any) => {
                    loading.value = false;
                    tableData.value = res?.content?.list || [];
                });
            };

        onMounted(() => {
            getTableData();
        });
        watch(dialogFormVisible, (newValue, oldValue) => {
            if (oldValue) {
                (formRef.value as any).resetFields();
                form.value = {
                    name: "",
                    sort: 1,
                    id: 0,
                };
                isEdit.value = false;
                dialogTitle.value = "新增方案";
                (formRef.value as any).resetFields();
            }
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            dialogFormVisible,
            dialogTitle,
            formRef,
            form,
            father,
            isEdit,
            edit,
            setStatus,
            submitForm,
            roleList,
        };
    },
});
